import { alias, date, identifier, serializable } from 'serializr';


export class IdEmailAddressEntity {
  @serializable(alias('createdAt', date()))
  private readonly _createdAt: Date;

  @serializable(alias('email'))
  private _emailAddress: string;

  @serializable(alias('primary'))
  private _primary: boolean = false;

  @serializable(alias('uuid', identifier()))
  private readonly _uuid: string;

  @serializable(alias('verifiedAt', date()))
  private readonly _verifiedAt: Date|null;

  public get createdAt(): Date {
    return this._createdAt;
  }

  public get emailAddress(): string {
    return this._emailAddress;
  }

  public set emailAddress(email: string) {
    this._emailAddress = email;
  }

  public get primary(): boolean {
    return this._primary;
  }

  public set primary(primary: boolean) {
    this._primary = primary;
  }

  public get uuid(): string {
    return this._uuid;
  }

  /**
   *
   */
  public get verified(): boolean {
    return !!this._verifiedAt;
  }
}
